export default {
  setContentContainerWidth(state, width) {
    if (width) {
      state.contentContainerWidth = width      
    }
  },
  setFilterIsNotLoaded(state, filter) {
    const filters = state.filtersToWaitForResults.filter((item) => item != filter)
    filters.push(filter)
    state.filtersToWaitForResults = filters
  },

  setFilterIsLoaded(state, filter) {
    state.filtersToWaitForResults = state.filtersToWaitForResults.filter((item) => item != filter)
  },

  setSidebarPolicyTooltipShouldHide(state, status) {
    state.sidebarPolicyTooltipShouldHide = status
  },
  setRedirectTo(state, { route = null, event = '' } = {}) {
    state.redirectTo = route
    state.redirectToEventToDispatchAfter = event
  },
  setDeviceInfo(state, { user_device, is_admin, is_team }) {
    state.deviceInfo = {
      ...user_device,
      is_admin,
      is_team
    }
  },
  setComponentStructureTracing(state, componentStructureTracing) {
    state.componentStructureTracing = componentStructureTracing
  },
  setQaHotKeyPressed(state, qaHotKeyPressed) {
    state.qaHotKeyPressed = qaHotKeyPressed
  }
}
